// extracted by css-extract-rspack-plugin
export default {"link":"_4e360c1f"};